
export const EDIT_CHANGE_LOG_FORM_PREV_VERSION_LABEL = "Номер предыдущей версии"

export const EDIT_CHANGE_LOG_FORM_PREV_VERSION_DESCRIPTION_LABEL = "Изменения предыдущей версии"
